import { render } from "./OnDemandExamRoom.vue?vue&type=template&id=30e06ca6&scoped=true&ts=true"
import script from "./OnDemandExamRoom.vue?vue&type=script&lang=ts"
export * from "./OnDemandExamRoom.vue?vue&type=script&lang=ts"

import "./OnDemandExamRoom.vue?vue&type=style&index=0&id=30e06ca6&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e06ca6"]])

export default __exports__